import ViewOrderContainer from './view-order-container';

export default ViewOrderContainer;
